import { IEnvironment } from "../interfaces/environment.interface";
import { getEnvironmentVariable } from "./environment.loader";

export const environment: IEnvironment = {
    API_URL: getEnvironmentVariable('API_URL', 'http://develop.engenharia-vd.totvs.io:15200/'),
    HOST_TOMAS: getEnvironmentVariable('HOST_TOMAS', 'https://us-central1-totvs-engenharia-varejo.cloudfunctions.net/tomas-log-dev')
};